import React from 'react';
import {
  PROCESSING_STAGES,
  STAGE_META,
  getStageState,
  getStageLabel,
  getStageIndex,
} from '../../constants';
import './ProcessingStepper.css';

interface ProcessingStepperProps {
  /** Raw backend stage string (may be unknown/undefined). */
  currentStage?: string;
}

/** Bootstrap Icons class for a step's status icon. */
function stepIcon(state: 'completed' | 'current' | 'upcoming', ownIcon: string): string {
  if (state === 'completed') return 'bi-check-circle-fill';
  if (state === 'current') return 'bi-hourglass-split';
  return ownIcon || 'bi-circle';
}

const ProcessingStepper: React.FC<ProcessingStepperProps> = ({ currentStage }) => {
  const isUnknownStage = Boolean(currentStage) && getStageIndex(currentStage) === -1;

  return (
    <div className="processing-stepper-wrap">
      <ol className="processing-stepper">
        {PROCESSING_STAGES.map((stage) => {
          const state = getStageState(currentStage, stage);
          const meta = STAGE_META[stage];
          return (
            <li
              key={stage}
              className={`step step--${state}`}
              aria-current={state === 'current' ? 'step' : undefined}
            >
              <span className="step-icon">
                <i className={`bi ${stepIcon(state, meta.icon)}${state === 'current' ? ' step-icon--spin' : ''}`}></i>
              </span>
              <span className="step-label">{meta.label}</span>
              <span className="visually-hidden">{state}</span>
            </li>
          );
        })}
      </ol>
      {isUnknownStage && (
        <p className="stepper-active-caption">{getStageLabel(currentStage)}…</p>
      )}
    </div>
  );
};

export default ProcessingStepper;
